import type { labelProviderInterface } from '../../../../../../LabelProviderInterface';
import { prepareSubstitutionToolUrl } from '../../../../conversational-search-logic/utils/utils';
import type { IConversationalSearchFollowUpActions } from './follow-up-actions';

export const VIEW_REPLACEMENTS_FOR = 'View recommended replacements for {0}';
export const REFINE_SUGGESTIONS = 'Refine suggestions with specific details';
export const SHARE_FEEDBACK = 'Share valuable feedback about the tool';

const createAction = (
  action: string,
  callback: Function,
  labelKey: string,
  labelProvider: labelProviderInterface,
  productIdsString?: string,
  redirectionUrl?: string
) => ({
  action,
  callback,
  text: labelProvider(labelKey, action),
  productIdsString,
  redirectionUrl
});

const createSubstitutionAction = (props: IConversationalSearchFollowUpActions) => {
    const productIdsString = props.substitutionProductsIds?.join(', ');
    const redirectionUrl = prepareSubstitutionToolUrl(
      props.conversationalSearchBrandUrl,
      props.country,
      props.language,
      props.substitutionProductsIds,
    );

    return props.substitutionProductsIds?.length
      ? createAction(
        VIEW_REPLACEMENTS_FOR,
        () => void 0,
        'conversational.search.follow.up.action.substitution',
        props.labelProvider,
        productIdsString,
        redirectionUrl
      )
      : null;
};

const createCharacteristicsAction = (props: IConversationalSearchFollowUpActions) => {
    return (props.refinementData?.length)
      ? createAction(
        REFINE_SUGGESTIONS,
        () => props.refineCallback(),
        'conversational.search.follow.up.action.refine',
        props.labelProvider
      )
      : null;
};

const createFeedbackAction = (props: IConversationalSearchFollowUpActions) =>
  createAction(
    SHARE_FEEDBACK,
    () => props.feedbackCallback(),
    'conversational.search.follow.up.action.feedback',
    props.labelProvider
  );

export const followUpActions = (
  props: IConversationalSearchFollowUpActions,
  actionOrder: string[]
) => {
    const actionCreatorsMap = {
      substitutionAction: createSubstitutionAction,
      characteristicsAction: createCharacteristicsAction,
    };

    const actions = actionOrder
      .map(actionKey => actionCreatorsMap[actionKey]?.(props))
      .filter(Boolean);

    // Add feddback followup only when another followup is present
    if (actions?.length > 0) actions.push(createFeedbackAction(props));

    return actions;
};
